var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        class:
          "c-search " +
          _vm.id +
          " " +
          (_vm.largeInput ? "c-search--lg" : "") +
          " " +
          (!_vm.useAnimation || _vm.isOpen ? "is-open" : "")
      },
      [
        _c(
          "form",
          {
            staticClass: "c-search__form",
            attrs: { action: _vm.url, method: "get", role: "search" }
          },
          [
            _c(
              "label",
              { staticClass: "t-visually-hidden", attrs: { for: _vm.id } },
              [_vm._v("Sök")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "controls",
                class:
                  "c-search__controls " +
                  (_vm.isOpen && _vm.useAnimation
                    ? "c-search__controls--open"
                    : "") +
                  " " +
                  (_vm.isAutocompleteVisible && _vm.items.length > 0
                    ? "c-search--open"
                    : "")
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchValue,
                      expression: "searchValue"
                    }
                  ],
                  ref: "searchInput",
                  staticClass: "c-search__input",
                  attrs: {
                    type: "search",
                    id: _vm.id,
                    name: "q",
                    placeholder: "Sök på mkbfastighet.se",
                    tabindex: "2",
                    autocomplete: "off",
                    "aria-expanded":
                      _vm.isAutocompleteVisible && _vm.items.length > 0
                        ? true
                        : false,
                    "aria-owns": _vm.isAutocompleteVisible
                      ? _vm.id + "_results"
                      : null,
                    "aria-autocomplete": "both"
                  },
                  domProps: { value: _vm.searchValue },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchValue = $event.target.value
                      },
                      function(e) {
                        return _vm.onInput(e.target.value)
                      }
                    ],
                    keydown: function($event) {
                      return _vm.listKeyPress($event)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.isLoading
                  ? [_vm._m(0)]
                  : [
                      _vm.isOpen && _vm.useAnimation
                        ? _c(
                            "button",
                            {
                              ref: "submit",
                              staticClass: "c-search__submit",
                              attrs: { type: "submit" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "t-visually-hidden c-search__button-text"
                                },
                                [_vm._v(_vm._s(_vm.submitText))]
                              ),
                              _vm._v(" "),
                              _c("v-icon", {
                                attrs: { name: "icon-search", size: "s" }
                              })
                            ],
                            1
                          )
                        : !_vm.isOpen && !_vm.useAnimation
                        ? _c(
                            "button",
                            {
                              ref: "submit",
                              staticClass: "c-search__submit",
                              attrs: { type: "submit" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "t-visually-hidden c-search__button-text"
                                },
                                [_vm._v(_vm._s(_vm.submitText))]
                              ),
                              _vm._v(" "),
                              _c("v-icon", {
                                attrs: { name: "icon-search", size: "s" }
                              })
                            ],
                            1
                          )
                        : _c(
                            "button",
                            {
                              ref: "submit",
                              staticClass: "c-search__submit",
                              attrs: { type: "submit" },
                              on: { click: _vm.openSearch }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "t-visually-hidden c-search__button-text"
                                },
                                [_vm._v(_vm._s(_vm.submitText))]
                              ),
                              _vm._v(" "),
                              _c("v-icon", {
                                attrs: {
                                  name: "icon-search",
                                  size: "s",
                                  "css-modifiers": "c-search--search-icon"
                                }
                              })
                            ],
                            1
                          )
                    ]
              ],
              2
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.isAutocompleteVisible && _vm.items.length > 0
                ? _c(
                    "ul",
                    {
                      ref: "list",
                      class:
                        "c-search__autocomplete " +
                        (_vm.isAutocompleteVisible && _vm.items.length > 0
                          ? "c-search__autocomplete--open"
                          : ""),
                      attrs: { id: _vm.id + "_results", role: "listbox" }
                    },
                    _vm._l(_vm.items, function(item, i) {
                      return _c("li", {
                        key: i,
                        staticClass:
                          "c-search__autocomplete-result t-text-color--emphasis",
                        class: { "is-active": i === _vm.selectedIndex },
                        attrs: {
                          role: "option",
                          "aria-selected":
                            i === _vm.selectedIndex ? true : false
                        },
                        domProps: {
                          innerHTML: _vm._f("highlight")(item, _vm.searchValue)
                        },
                        on: {
                          click: function($event) {
                            return _vm.setResult(item, i)
                          }
                        }
                      })
                    }),
                    0
                  )
                : _vm._e()
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.useAnimation
          ? _c(
              "button",
              {
                ref: "close",
                staticClass: "c-button c-button--noboxshadow c-search__close",
                attrs: { type: "button" },
                on: { click: _vm.closeSearch }
              },
              [
                _c("span", { staticClass: "t-visually-hidden" }, [
                  _vm._v("Stäng sök")
                ]),
                _vm._v(" "),
                _c("v-icon", {
                  attrs: {
                    name: "icon-close",
                    size: "xxs",
                    "css-modifiers": "c-search--close-icon"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "c-search__loading-wrapper",
        attrs: { "aria-live": "assertive" }
      },
      [
        _c("div", { staticClass: "c-search__loading" }, [
          _c("div", {
            staticClass: "c-search__circle",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "c-search__text t-visually-hidden" }, [
            _vm._v("Söker fram alternativ...")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }